/* unplugin-vue-components disabled */import { render } from "./takeTest.vue?vue&type=template&id=6c7878a4&scoped=true"
import script from "./takeTest.vue?vue&type=script&lang=js"
export * from "./takeTest.vue?vue&type=script&lang=js"

import "./takeTest.vue?vue&type=style&index=0&id=6c7878a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7878a4"]])

export default __exports__